
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sitemap/nfl-scores",
      function () {
        return require("private-next-pages/sitemap/nfl-scores.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sitemap/nfl-scores"])
      });
    }
  